<div class="st-drawer-wrapper">
  <div class="st-drawer-header">
    <span class="text-header-16 text-semibold">{{ isEditMode ? 'Editar actividad' : 'Programar actividad' }}</span>
    <app-st-icon (click)="close()" class="text-header-16 cursor-pointer" [name]="'close'" [bold]="true"></app-st-icon>
  </div>

  <form class="st-drawer-content st-form" nz-form [formGroup]="activityForm">
    <!-- Primera fila: Tipo de actividad y Fecha de vencimiento -->
    <div nz-row [nzGutter]="16">
      <!-- Tipo de actividad -->
      <div nz-col [nzXs]="24" [nzSm]="12">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>Tipo de actividad:</nz-form-label>
          <nz-form-control nzErrorTip="Selecciona un tipo de actividad">
            <nz-select
              nzSize="large"
              formControlName="activityTypeId"
              nzPlaceHolder="Selecciona tipo de actividad..."
              [nzLoading]="loadingActivityTypes"
              [nzSuffixIcon]="customSelectIcon">
              <nz-option *ngFor="let type of activityTypes" [nzValue]="type.id" [nzLabel]="type.name"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Fecha de vencimiento -->
      <div nz-col [nzXs]="24" [nzSm]="12">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>Fecha de vencimiento</nz-form-label>
          <nz-form-control nzErrorTip="Selecciona una fecha">
            <nz-date-picker
              nzSize="large"
              class="w-100"
              formControlName="dateDeadLine"
              [nzShowTime]="{ nzFormat: 'HH:mm' }"
              nzFormat="MMM dd, yyyy"
              nzPlaceHolder="Selecciona una fecha"
              [nzSuffixIcon]="suffixTmpl">
            </nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <!-- Segunda fila: Layout según contexto -->
    @if (context === 'activity-panel') {
      <!-- Activity-panel: Resumen y Asignado a en la misma fila -->
      <div nz-row [nzGutter]="16">
        <!-- Resumen -->
        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Resumen</nz-form-label>
            <nz-form-control nzErrorTip="Ingresa un resumen">
              <input
                nz-input
                nzSize="large"
                formControlName="summary"
                placeholder="p. ej. Discutir propuesta" />
            </nz-form-control>
          </nz-form-item>
        </div>

        <!-- Asignado a -->
        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Asignado a:</nz-form-label>
            <nz-form-control nzErrorTip="Selecciona un usuario">
              <nz-select
                nzSize="large"
                formControlName="assignedUserId"
                nzPlaceHolder="Selecciona usuario..."
                [nzLoading]="loadingUsers"
                nzShowSearch
                [nzSuffixIcon]="customSelectIcon">
                <nz-option
                  *ngFor="let user of commercialUsers"
                  [nzValue]="user.id"
                  [nzLabel]="user.name"
                  nzCustomContent>
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <nz-avatar [nzText]="user.initials" [nzSize]="24" style="background-color: #e8e8e8; color: #333; font-size: 10px;"></nz-avatar>
                    <span>{{ user.name }}</span>
                  </div>
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <!-- Tercera fila: Registrar una nota -->
      <div nz-row [nzGutter]="16">
        <div nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Registrar una nota</nz-form-label>
            <nz-form-control>
              <textarea
                nz-input
                nzSize="large"
                formControlName="note"
                placeholder="Escribe una nota..."
                [nzAutosize]="{ minRows: 3, maxRows: 6 }">
              </textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    } @else {
      <!-- Activities-feature: Resumen a todo lo ancho -->
      <div nz-row [nzGutter]="16">
        <div nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Resumen</nz-form-label>
            <nz-form-control nzErrorTip="Ingresa un resumen">
              <textarea
                nz-input
                nzSize="large"
                formControlName="summary"
                placeholder="p. ej. Discutir propuesta"
                [nzAutosize]="{ minRows: 3, maxRows: 6 }">
              </textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <!-- Tercera fila: Asignado a -->
      <div nz-row [nzGutter]="16">
        <div nz-col [nzSpan]="24">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Asignado a:</nz-form-label>
            <nz-form-control nzErrorTip="Selecciona un usuario">
              <nz-select
                nzSize="large"
                formControlName="assignedUserId"
                nzPlaceHolder="Selecciona usuario..."
                [nzLoading]="loadingUsers"
                nzShowSearch
                [nzSuffixIcon]="customSelectIcon">
                <nz-option
                  *ngFor="let user of commercialUsers"
                  [nzValue]="user.id"
                  [nzLabel]="user.name"
                  nzCustomContent>
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <nz-avatar [nzText]="user.initials" [nzSize]="24" style="background-color: #e8e8e8; color: #333; font-size: 10px;"></nz-avatar>
                    <span>{{ user.name }}</span>
                  </div>
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    }
  </form>

  <div class="st-drawer-footer">
    <button (click)="close()" class="text-btn-14" nz-button nzType="text" nzShape="round" nzSize="large">
      Cancelar
    </button>
    <div style="display: flex; gap: 8px;">
      <button
        *ngIf="showCalendarButton"
        nz-button
        nz-dropdown
        [nzDropdownMenu]="calendarDropdownMenu"
        nzTrigger="click"
        class="text-btn-14"
        nzType="default"
        nzShape="round"
        nzSize="large">
        <app-st-icon name="calendar_today" style="margin-right: 4px;"></app-st-icon>
        <span>Añadir al calendario</span>
        <app-st-icon name="keyboard_arrow_down" style="margin-left: 4px;"></app-st-icon>
      </button>
      <button
        *ngIf="!isEditMode"
        (click)="scheduleAndNext()"
        [disabled]="!activityForm.valid || scheduling"
        class="text-btn-14"
        nz-button
        nzType="default"
        nzShape="round"
        nzSize="large">
        <span>Hecho y programar siguiente</span>
      </button>
      <button
        (click)="scheduleActivity()"
        [disabled]="!activityForm.valid || scheduling"
        class="text-btn-14"
        nz-button
        nzType="primary"
        nzShape="round"
        nzSize="large">
        <app-st-icon *ngIf="scheduling" class="prefix" [name]="'progress_activity'" [bold]="true"></app-st-icon>
        <span>{{ isEditMode ? 'Guardar' : 'Programar' }}</span>
      </button>
    </div>
  </div>
</div>

<ng-template #customSelectIcon>
  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
</ng-template>


<ng-template #suffixTmpl>
  <app-st-icon style="font-size: 20px" color="#666666" [bold]="true" name="calendar_today"></app-st-icon>
</ng-template>

<ng-template #emtySuffixTmpl>
</ng-template>

<ng-template #extraFooterTpl>
  <div style="text-align: center; padding: 8px 0; color: #666; font-size: 12px;">
    Local ({{ timezone }}) <app-st-icon name="keyboard_arrow_down" style="font-size: 12px;"></app-st-icon>
  </div>
</ng-template>

<nz-dropdown-menu #calendarDropdownMenu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item (click)="openGoogleCalendar()">
      <div style="display: flex; align-items: center; gap: 8px;">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M19.5 4H18V2H16V4H8V2H6V4H4.5C3.67 4 3 4.67 3 5.5V20.5C3 21.33 3.67 22 4.5 22H19.5C20.33 22 21 21.33 21 20.5V5.5C21 4.67 20.33 4 19.5 4Z" fill="#4285F4"/>
          <path d="M19 20H5V9H19V20Z" fill="#FFFFFF"/>
          <path d="M12 13.5L8.5 17H15.5L12 13.5Z" fill="#34A853"/>
          <path d="M8.5 17L12 13.5V10.5L8.5 14V17Z" fill="#FBBC04"/>
          <path d="M15.5 17L12 13.5V10.5L15.5 14V17Z" fill="#EA4335"/>
        </svg>
        <span>Google Calendar</span>
      </div>
    </li>
    <li nz-menu-divider></li>
    <li nz-menu-item (click)="downloadIcsFile()">
      <div style="display: flex; align-items: center; gap: 8px;">
        <app-st-icon name="download" style="font-size: 16px; color: #666;"></app-st-icon>
        <span>Descargar .ics</span>
      </div>
    </li>
  </ul>
</nz-dropdown-menu>

<ng-template #quickRangeDropdown>
  <nz-dropdown-menu #quickRangeMenu="nzDropdownMenu">
    <ul nz-menu>
      <li nz-menu-item (click)="onQuickRangeChange('last3days')">Last 3 Days</li>
      <li nz-menu-item (click)="onQuickRangeChange('last7days')">Last 7 Days</li>
      <li nz-menu-item (click)="onQuickRangeChange('last14days')">Last 14 Days</li>
      <li nz-menu-item (click)="onQuickRangeChange('lastMonth')">Last Month</li>
    </ul>
  </nz-dropdown-menu>
  <span nz-dropdown [nzDropdownMenu]="quickRangeMenu" nzTrigger="click" style="cursor: pointer; padding: 0 8px;">
    <app-st-icon name="keyboard_arrow_down"></app-st-icon>
  </span>
</ng-template>

<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor"
             [showUndo]="toastConfig.showUndo"
             [notRef]="notRef" [content]="toastConfig.content" [msg]="toastConfig.msg"></app-toast>
</ng-template>
